export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "Wpisz tutaj swoją odpowiedź",
      conversationalPlaceholder: "Wpisz tutaj swoją odpowiedź",
      conversationClosed: "Rozmowa zakończona.",
      conversationalDisclaimer: "Pytania uzupełniające będą generowane przez AI na podstawie Twoich odpowiedzi."
    },
    openText: {
      openEndPlaceholder: "Wpisz tutaj swoją odpowiedź"
    },
    multiText: {
      fieldPlaceholder: 'Odpowiedź {number}',
      instruction: 'Wpisz poniżej odpowiedzi, po jednej w każdym polu tekstowym. Minimalna liczba: {count}.',
      instructionWithoutMinimum: 'Wpisz poniżej swoje odpowiedzi, po jednej w każdym polu tekstowym',
      minimumEntries: 'Aby kontynuować, wpisz odpowiedzi. Minimalna liczba: {count}.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Marka {number}',
        minimumEntries: 'Aby kontynuować, wpisz marki. Minimalna liczba: {count}.'
      }
    },
    multiselect: {
      caption: "Zaznacz wszystkie pasujące odpowiedzi"
    },
    rankOrder: {
      enterRankOrder: "Wprowadź kolejność",
      placeholder: "Przeciągnij tutaj swoje wybory, aby je uporządkować"
    },
    openNumeric: {
      label: "Otwarta odpowiedź liczbowo"
    },
    complete: {
      message: "Dziękujemy za wypełnienie ankiety."
    },
    openVideo: {
      warning: "Proszę nagrać wideo przed kontynuowaniem.",
      uploadStatusUploading: "Poczekaj, aż przetworzymy Twoje wideo, aby kontynuować...",
      uploadStatusSuccess: "Przesyłanie zakończone powodzeniem, możesz kontynuować.",
      uploadStatusError: "Przesyłanie nie zostało ukończone, spróbuj ponownie."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Podaj prawidłowy adres e-mail',
      text_invalid_phone: 'Podaj prawidłowy numer telefonu',
      text_invalid_us_zip: 'Podaj prawidłowy amerykański kod ZIP',
      text_invalid_ca_postal: 'Podaj prawidłowy kod pocztowy Kanady',
      text_invalid_uk_postal: 'Podaj prawidłowy kod pocztowy Wielkiej Brytanii',
      text_invalid_custom: 'Podaj prawidłowy {fieldName}',
      text_min_chars: 'Wpisz co najmniej {min} znaków',
      text_max_chars: 'Wpisz nie więcej niż {max} znaków',
      text_alpha_not_allowed: 'Dozwolone są tylko cyfry',
      text_numeric_not_allowed: 'Dozwolone są tylko litery'
    },
    external: {
      invalid: 'Odpowiedź na to pytanie jest nieprawidłowa.',
      required: 'Odpowiedź na to pytanie jest wymagana.',
      singlechoice_required: 'Proszę wybrać opcję przed kontynuowaniem.',
      numeric_required: 'Proszę wybrać ocenę przed kontynuowaniem.',
      text_required: 'Proszę wprowadzić odpowiedź przed kontynuowaniem.',
      bigtext_required: 'Proszę wprowadzić odpowiedź przed kontynuowaniem.',
      singlechoiceother_incomplete: 'Proszę wprowadzić odpowiedź przed kontynuowaniem.',
      multiselectother_incomplete: 'Proszę wprowadzić odpowiedź przed kontynuowaniem.',
      numeric_invalid: 'Proszę wprowadzić prawidłową liczbę przed kontynuowaniem.',
      radiogrid_required: 'Proszę wybrać opcję dla każdego wiersza przed kontynuowaniem.',
      incomplete: 'Zanim przejdziesz dalej, w pełni odpowiedz na to pytanie.',
      multiselect_min: 'Proszę wybrać co najmniej {value} opcji przed kontynuowaniem.',
      multiselect_max: 'Proszę wybrać nie więcej niż {value} opcji przed kontynuowaniem.',
      multiselectother_min: 'Proszę wybrać co najmniej {value} opcji przed kontynuowaniem.',
      multiselectother_max: 'Proszę wybrać nie więcej niż {value} opcji przed kontynuowaniem.',
      multiselectgrid_min: 'Proszę wybrać co najmniej {value} opcji dla każdego wiersza przed kontynuowaniem.',
      multiselectgrid_max: 'Proszę wybrać nie więcej niż {value} opcji dla każdego wiersza przed kontynuowaniem.',
      rankorder_min: 'Proszę ocenić co najmniej {value} elementów przed kontynuowaniem.',
      rankorder_max: 'Proszę ocenić nie więcej niż {value} elementów przed kontynuowaniem.'
    }
  }
}
